<template>
  <section class=" card">

    <header class="card-header">
      <p class="card-header-title">TowerEye Number</p>
      <button class="card-header-icon">
      <span >
        <b-tag type="is-grey-light">Silver 70x32</b-tag>
      </span>
      </button>

    </header>
    <div class="card-content">
      <b-field label="TE Number incl TE">
        <b-input v-model="line1" value="E.g. TE233" maxlength="5">
        </b-input>
      </b-field>

      <b-field grouped>
        <b-field label="Show Preview">
          <p class="control">
            <b-button class="button is-primary" @click="previewZPL">Preview</b-button>
          </p>
        </b-field>

        <b-field
            label="Amount"
            type="is-primary">
          <b-select v-model="amountOfLabels">
            <option :value="1">1</option>
            <option :value="2">2</option>
            <option :value="3">3</option>
            <option :value="4">4</option>
            <option :value="5">5</option>
            <option :value="6">6</option>
          </b-select>
        </b-field>
        <b-field label="Print">
          <b-button @click="printZPL">
            Print Tags
          </b-button>
        </b-field>
      </b-field>


    </div>

  </section>
</template>

<script>

import moment from "moment/moment";

export default {
  data() {
    return {
      amountOfLabels: 1,
      line1: '',
    };
  },
  methods: {

    previewZPL() {
      this.$emit("previewZPL", this.generateLabelZPL())
    },

    printZPL() {

      let res = []
      for (let i = 0; i < this.amountOfLabels; i++) {
        res.push(this.generateLabelZPL())
      }

      this.$emit("printZPL", res)
    },

    generateLabelZPL() {
      return `^XA^PW560^CF0,35
              ^FO170,45^FDTowerEye^FS
              ^FO130,40^GFA,128,128,4,KF8,LF,LFC,LFE,MF,MF8IF007FCFFC003FCFF8001FEFFJ0FEFEJ07EFEJ07!FCJ03!FC03E03!FC07E03!FC07F03!:FC07E03!FC03E03!FCJ03!FEJ07!7EJ07!7FJ0!7F8001!3FC003!1FF007!1!0!07!03!00!001!^FS
              ^CF0,120^FO130,100^FB520,2,5,L,0^FD${this.line1}^FS
              ^XZ`
    },

  },
};
</script>
